module.exports = __webpack_public_path__ + "img/appleStoreBg.1e5b83ad.png";